import Quill from 'quill';
import type QuillEmbed from 'quill/blots/embed';

const Embed = Quill.import('blots/embed') as QuillEmbed;

interface MentionBlotData {
  denotationChar: string;
  value: string;
  id?: string | number;
  [key: string]: any;
}

// @ts-ignore
class MentionBlot extends Embed {
  static blotName = 'mention';
  static tagName = 'span';
  static className = 'mention';

  static create(data: MentionBlotData) {
    // biome-ignore lint/complexity/noThisInStatic: <explanation>
    const node = super.create();

    const denotationChar = document.createElement('span');
    denotationChar.className = 'ql-mention-denotation-char';
    denotationChar.innerHTML = data.denotationChar;
    denotationChar.setAttribute('contenteditable', 'false');

    const dataContainer = document.createElement('span');
    dataContainer.innerHTML = data.value;
    dataContainer.setAttribute('contenteditable', 'false');

    // 修復 Android 上，當光標聚焦到 contenteditable="false" 的元素時，鍵盤會自動關閉。
    // 創建一個可見的緩衝區元素，插入空白字符並設置樣式，讓鍵盤認為有可編輯的內容，保持鍵盤打開。
    const AndroidBackspaceFix = document.createElement('span');
    AndroidBackspaceFix.innerHTML = '&nbsp;';
    AndroidBackspaceFix.setAttribute('style', 'display: inline-block; height: 1px; width: 1px; overflow: hidden; ');

    node.appendChild(denotationChar);
    node.appendChild(dataContainer);
    node.appendChild(AndroidBackspaceFix);

    return MentionBlot.setDataValues(node, data);
  }

  static setDataValues(element: HTMLElement, data: MentionBlotData) {
    // 覆蓋 Embed 構造函數默認為最外層 <span> 設置 contenteditable="false" 的行為，
    // 改為在 create() 方法內為子元素單獨設置 contenteditable。
    setTimeout(() => {
      element.getElementsByTagName('span')[0]?.setAttribute('contenteditable', 'inherit');
    }, 0);

    const domNode = element;

    for (const [key, value] of Object.entries(data)) {
      domNode.dataset[key] = value;
    }

    return domNode;
  }

  static value(domNode: HTMLElement) {
    return domNode.dataset;
  }

  /**
   * 處理 Android Gboard 退格鍵的異常行為，避免光標進入只讀的 Blot 區域並破壞結構。
   * - 忽略 contenteditable 屬性的安全變更。
   * - 發現其他不安全變更時，延遲刪除整個 Blot
   */

  update(mutations: MutationRecord[]) {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'contenteditable') continue;
      setTimeout(() => (this as any).remove(), 0);
      return;
    }
  }
}

export default MentionBlot;
